import React, { ReactNode } from 'react';
import classNames from 'classnames';

import { useScreenSize } from '@hcs/hooks';

import { DirectionalChevron } from '../../../../foundations';
import { CloseButton, TextButton } from '../../../controls-and-inputs';

import styles from './Header.module.css';

/* This should match the --global-header-height-phone var in variables.css */
export const HEADER_HEIGHT_PHONE = 40;
/* This should match the --global-header-height var in variables.css */
export const HEADER_HEIGHT_DESKTOP = 80;

export interface HeaderProps {
  /**
   * Required automation and engagement HTML attribute.
   */
  dataHcName: string;
  dataHcEventSection?: string;
  /**
   * Optional className applied to main HTML element.
   */
  className?: string;
  /** Title text */
  title?: ReactNode;
  /** Height of header */
  size?: 'lg' | 'sm' | 'xs';
  /** Show Back Button */
  onBack?: VoidFunction;
  /** Show Close Button */
  onClose?: VoidFunction;
  children?: ReactNode;
  theme?: {
    HeaderContent?: string;
  };
  xsOnPhone?: boolean;
}
export const Header = ({
  dataHcName,
  dataHcEventSection,
  className,
  children,
  size = 'lg',
  title,
  onBack,
  onClose,
  theme,
  xsOnPhone = false,
}: HeaderProps) => {
  const { isPhoneWidth } = useScreenSize();
  return (
    <header
      data-hc-name={`${dataHcName}-header`}
      data-hc-event-section={dataHcEventSection}
      className={classNames(
        styles.Header,
        styles[size],
        {
          [styles.xs]: xsOnPhone && isPhoneWidth,
        },
        className,
        {
          [styles.noBack]: !onBack,
        },
      )}
    >
      {onBack && (
        <TextButton
          className={styles.ChevronButton}
          dataHcName={`${dataHcName}-close-button`}
          onClick={onBack}
          icon={
            <DirectionalChevron
              dataHcName={`${dataHcName}-DirectionalChevron`}
              direction="left"
              size="sm"
            />
          }
        >
          Back
        </TextButton>
      )}
      <div className={classNames(styles.HeaderContent, theme?.HeaderContent)}>
        {title && (
          <h1 data-hc-name={`${dataHcName}-title`} className={styles.Title}>
            {title}
          </h1>
        )}
        {children}
      </div>
      {onClose && (
        <CloseButton
          dataHcName={`${dataHcName}-closeButton`}
          onClick={onClose}
        />
      )}
    </header>
  );
};
